import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import { Picture } from 'formlabs-web-components/Media';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Link } from 'formlabs-web-components/Link';
import './SocialMediaIcons.module.css';
import CountryContext from '../../context/country';

import weChat from '../../../../public/wechat.jpg';

const SocialMediaIcons = DisplayComponent(
  class SocialMediaIcons extends PureComponent {
    static contextType = CountryContext;
    render() {
      const { color, iconSize, align, spaceBetween, classes, t } = this.props;
      const {
        facebookUrl,
        twitterUrl,
        instagramUrl,
        youtubeUrl,
        linkedinUrl,
        language
      } = this.context;

      let style;
      if (align === 'center') {
        style = { margin: `calc(${spaceBetween} / 2)`, fontSize: iconSize };
      }
      if (align === 'left') {
        style = { marginRight: spaceBetween, fontSize: iconSize };
      }
      if (align === 'right') {
        style = { marginLeft: spaceBetween, fontSize: iconSize };
      }
      return (
        <div
          styleName={`${align || 'left'} ${color || 'black'} `}
          className={classes}
        >
          <Link
            to={facebookUrl}
            openInNewWindow={true}
            aria-label={t('Formlabs Facebook page')}
          >
            <i className="fl-facebook" style={style} />
          </Link>
          <Link
            to={twitterUrl}
            openInNewWindow={true}
            aria-label={t('Formlabs Twitter page')}
          >
            <i className="fl-twitter" style={style} />
          </Link>
          <Link
            to={instagramUrl}
            openInNewWindow={true}
            aria-label={t('Formlabs Instagram page')}
          >
            <i className="fl-instagram" style={style} />
          </Link>
          <Link
            to={youtubeUrl}
            openInNewWindow={true}
            aria-label={t('Formlabs Youtube page')}
          >
            <i className="fl-youtube" style={style} />
          </Link>
          <Link
            to={linkedinUrl}
            openInNewWindow={true}
            aria-label={t('Formlabs LinkedIn page')}
          >
            <i className="fl-linkedin" style={style} />
          </Link>
          {language === 'zh' && (
            <Picture
              imageStyles={{
                padding: '1rem 0',
                display: 'block',
                clear: 'both'
              }}
              largeImage={weChat}
              alt="http://weixin.qq.com/r/4ijSyrLEc_8Mrfap933w"
              width={180}
            />
          )}
        </div>
      );
    }
  }
);

SocialMediaIcons.propTypes = {};

export default withTranslation()(SocialMediaIcons);
